// ============================================================
// Modalità debug: pannelli Leva e Perf visibili SOLO aggiungendo
// ?debug all'URL (es. https://tuosito.vercel.app/?debug) oppure
// #debug. I visitatori normali non vedono nessun pannello.
// ============================================================
export const DEBUG_MODE =
  typeof window !== 'undefined' &&
  (new URLSearchParams(window.location.search).has('debug') ||
    window.location.hash === '#debug')
